import { v4 as uuid } from 'uuid';

const toExtendedWithUniqueIdenfitier = (key) => (item) => ({ ...item, [key]: uuid().toString() });

export default function(items, key) {
  return items.map(toExtendedWithUniqueIdenfitier(key));
}
